import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AppointmentModalComponent } from '../../appointment-modal/appointment-modal.component';

import { Overlay, BlockScrollStrategy } from '@angular/cdk/overlay';
import { MAT_MENU_SCROLL_STRATEGY } from '@angular/material/menu';

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}

@Component({
  selector: 'app-card-offers',
  templateUrl: './card-offers.component.html',
  styleUrls: ['./card-offers.component.scss'],
  providers: [
    { provide: MAT_MENU_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] }
  ]
})
export class CardOffersComponent implements OnInit {

  checked = false;

  constructor(private dialog: MatDialog,) { }

  ngOnInit(): void {
  }

  highlightChecked= (): void => {
    this.checked = true;
  }

  openAppointmentDialog = (): void => {
    const appointmentConfig = new MatDialogConfig();
    appointmentConfig.panelClass = 'green-modal';
    appointmentConfig.maxWidth = '100vw';
    this.dialog.open(AppointmentModalComponent, appointmentConfig);
  }

}
